export const IS_LOADING="IS_LOADING";
export const GET_CATEGORIES="GET_CATEGORIES";
